<script>
import { ScrollCarousel } from '@rei/recommendations-slider';
import { CdrBreakpointLg, CdrSpaceTwoX } from '@rei/cdr-tokens';
import headingSection from '../../../pages/home/components/headingSection/headingSection.vue';
import InfoCard from './InfoCard.vue';

export default {
  name: 'InfoCards',
  components: {
    InfoCard,
    headingSection,
    ScrollCarousel,
  },
  props: {
    heading: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    cards: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    visualConfiguration: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      containerWidth: Number(CdrBreakpointLg) - (Number(CdrSpaceTwoX) * 2),
      slidesToShow: this.visualConfiguration.shownCards,
      slidesToScroll: 1,
      slidesGap: 10,
    };
  },
  computed: {
    slides() {
      return this.cards.map((item, idx) => ({
        key: idx.toString(),
        props: {
          ...item,
        },
      }));
    },
    slideWidth() {
      const totalGapsWidth = (this.slidesToShow - 1) * this.slidesGap;
      return (this.containerWidth - totalGapsWidth) / this.slidesToShow;
    },
  },
};
</script>
<template>
  <div class="info-cards">
    <heading-section
      v-if="heading && heading?.heading?.text"
      :heading="heading.heading.text"
    />
    <scroll-carousel
      class="info-cards__rail"
      :class="heading && heading?.heading?.text ? '' : 'no-heading'"
      :slides="slides"
      :slides-gap="slidesGap"
      :slides-to-show="slidesToShow"
      :slides-to-scroll="slidesToScroll"
      :is-showing-arrows="true"
    >
      <template #slide="card">
        <info-card
          v-bind="card"
          :key="`info-card-${card.index}`"
          :palette="visualConfiguration.palette"
        />
      </template>
    </scroll-carousel>
  </div>
</template>
<style lang="scss" scoped>
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

.info-cards {
  :deep(.scroll-carousel__viewport) {
    --slide-width: v-bind(slideWidth);
    padding-left: 0;
  }
  .no-heading {
    margin-top: $cdr-space-one-and-a-half-x;
  }
}
</style>
